const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function AlphabetFilter({ selected, onSelect }) {
  return (
    <div data-testid="alphabet-filter" className="flex flex-wrap gap-1">
      <button
        data-testid="alphabet-all"
        onClick={() => onSelect(null)}
        className={`w-8 h-8 text-xs font-mono font-bold border transition-colors ${
          !selected ? "bg-[#09090B] text-white border-[#09090B]" : "bg-white text-zinc-500 border-border hover:bg-zinc-50 hover:text-zinc-900"
        }`}
      >
        All
      </button>
      {LETTERS.map((l) => (
        <button
          key={l}
          data-testid={`alphabet-${l}`}
          onClick={() => onSelect(l)}
          className={`w-8 h-8 text-xs font-mono font-bold border transition-colors ${
            selected === l ? "bg-[#09090B] text-white border-[#09090B]" : "bg-white text-zinc-500 border-border hover:bg-zinc-50 hover:text-zinc-900"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
